// since the error might be coming from a different window the prototype chain might be different
export function isError(o: unknown): o is Error {
  return !!(o instanceof Error || (typeof o === "object" && o && "name" in o && "message" in o))
}
